/* tslint:disable */
import Moment from 'moment';
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Modal, UncontrolledTooltip } from 'reactstrap';
import { Notification } from '../../../../components/notification/main';
import Paginate from '../../../../components/table/paginate';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import {
    FilterInitialValues,
    IAssignmentGradeFiles,
    IAssignmentGradeProps,
    IAssignmentGradeStudentItem
} from '../../../../models/components/assignment-grade-modal';
import * as Actions from '../../../../store/actions/coursePage';
import * as MessageActions from '../../../../store/actions/messages';
import { SecureImage } from '../../../core/secureImage';
import Loading from '../../../loading/loading';
import ProgressCircle from '../../../progress-circle/progress-circle';
import { timingSafeEqual } from 'crypto';
import logger from 'redux-logger';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { MessagesService } from '../../../../api/message-services';
import BaseModal from '../../../../modal/base-modal/main';
const _logger = Log.create('Processing Activity');
const T = Translator.create();
let _common: Common;
const messagesService = new MessagesService();

class BulkGrade extends React.Component<IAssignmentGradeProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            filters: Object.assign({}, FilterInitialValues),
            isSearchBoxOpen: false,
            derivedState: false,
            scoreTable: []
        };
    }

    render() {
        return (<>
            <div className="info-box">
                <p><span>{this.props.results!.length} {T.t('r_assignment_bulk_grade_people')} </span> {T.t('r_assignment_bulk_grade_people_desc_2')}</p>
            </div>
            <h5>{T.t('r_grade')}</h5>
            <div className="form-input form-group note-pad mb-0" style={{minHeight:'169px'}}>
            <input id="bulkGradeInput" 
            // tslint:disable-next-line:jsx-no-lambda
            onChange= {(e: any) =>{this.props.bulkGradeOnChange(e)}} type="number" placeholder={T.t('r_course_grade_bulk_placeholder')} />
            </div>
        </>)
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAssignmentGradeProps): IAssignmentGradeProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAssignmentGradeProps = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        activityCardItems: state.coursePage.activityCard,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        assignmentGradeInformation: state.coursePage.assignmentGradeInformation,
        assignmentGradeSaveResult: state.coursePage.assignmentGradeSaveResult,
        filters: state.coursePage.assignmentGradeStudentList ? state.coursePage.assignmentGradeStudentList.filters : {},
        results: state.coursePage.assignmentGradeStudentList ? state.coursePage.assignmentGradeStudentList.results : [],
        userPreferences: state.profile.userPreferences.preferences,
        groupId: state.assignment.groupId
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return false;
};

const CBulkGrade = connect(
    mapStateToProps,
    dispatchProps,
    null,
    { areStatesEqual }
)(BulkGrade);

export default CBulkGrade;
